(function() {
  'use strict';

  var SPEEDS = { 1: 0.05, 2: 0.12, 3: -0.06 };

  function update(section) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;
    var isNarrowViewport = window.innerWidth <= 1069;
    var cards = section.querySelectorAll('.ingredients-parallax__card');

    if (reduceMotion || isDesignMode || isNarrowViewport) {
      cards.forEach(function(card) { card.style.transform = ''; });
      return;
    }

    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight;
    var center = rect.top + rect.height / 2;
    var offset = center - vh / 2;

    cards.forEach(function(card) {
      var idx = parseInt(card.getAttribute('data-parallax-index'), 10) || 1;
      var speed = SPEEDS[idx] || 0;
      var y = Math.round(offset * speed);
      card.style.transform = 'translate3d(0,' + y + 'px,0)';
    });
  }

  function init(section) {
    if (!section || section.dataset.ingredientsParallaxInit) return;
    section.dataset.ingredientsParallaxInit = '1';

    var ticking = false;
    function onFrame() {
      if (!ticking) {
        requestAnimationFrame(function() {
          update(section);
          ticking = false;
        });
        ticking = true;
      }
    }

    update(section);
    window.addEventListener('scroll', onFrame, { passive: true });
    window.addEventListener('resize', onFrame);

    section._ingredientsParallaxCleanup = function() {
      window.removeEventListener('scroll', onFrame);
      window.removeEventListener('resize', onFrame);
      delete section.dataset.ingredientsParallaxInit;
      delete section._ingredientsParallaxCleanup;
    };
  }

  function run() {
    document.querySelectorAll('.ingredients-parallax[data-ingredients-parallax]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var el = event.detail.querySelector('.ingredients-parallax[data-ingredients-parallax]');
      if (el) init(el);
    });
    document.addEventListener('shopify:section:unload', function(event) {
      var el = event.detail.querySelector('.ingredients-parallax[data-ingredients-parallax]');
      if (el && el._ingredientsParallaxCleanup) el._ingredientsParallaxCleanup();
    });
  }
})();
